export default "__VITE_ASSET__DoCycmmQ__"